// import SatoshiVariableWOFF2 from "../fonts/Satoshi-Variable.woff2";
// const Satosh1iVariable = `@font-face {
//   font-family: "Satoshi-Variable";
//   src: url(${SatoshiVariableWOFF2}) format("woff2");
//   font-weight: 100 300 900;
//   font-display: swap;
//   font-style: normal;
// }`;

// import SatoshiVariableItalicWOFF2 from "../fonts/Satoshi-VariableItalic.woff2";
// const SatoshiVariableItalic = `@font-face {
//   font-family: "Satoshi-VariableItalic";
//   src: url(${SatoshiVariableItalicWOFF2}) format("woff2");
//   font-weight: 300 900;
//   font-display: swap;
//   font-style: italic;
// }`;

// import SatoshiLightWOFF2 from "../fonts/Satoshi-Light.woff2";
// const SatoshiLight = `@font-face {
//   font-family: "Satoshi-Light";
//   src: url(${SatoshiLightWOFF2}) format("woff2");
//   font-weight: 300;
//   font-display: swap;
//   font-style: normal;
// }`;

// import SatoshiLightItalicWOFF2 from "../fonts/Satoshi-LightItalic.woff2";
// const SatoshiLightItalic = `@font-face {
//   font-family: "Satoshi-LightItalic";
//   src: url(${SatoshiLightItalicWOFF2}) format("woff2");
//   font-weight: 300;
//   font-display: swap;
//   font-style: italic;
// }`;

// import SatoshiRegularWOFF2 from "../fonts/Satoshi-Regular.woff2";
// const SatoshiRegular = `@font-face {
//   font-family: "Satoshi-Regular";
//   src: url(${SatoshiRegularWOFF2}) format("woff2");
//   font-weight: 400;
//   font-display: swap;
//   font-style: normal;
// }`;

// import SatoshiRegularItalicWOFF2 from "../fonts/Satoshi-RegularItalic.woff2";
// const SatoshiRegularItalic = `@font-face {
//   font-family: "Satoshi-RegularItalic";
//   src: url(${SatoshiRegularItalicWOFF2}) format("woff2");
//   font-weight: 400;
//   font-display: swap;
//   font-style: italic;
// }`;

import SatoshiMediumWOFF2 from "../fonts/Satoshi-Medium.woff2";
const SatoshiMedium = `@font-face {
  font-family: "Satoshi-Medium";
  src: url(${SatoshiMediumWOFF2}) format("woff2");
  font-weight: 500;
  font-display: swap;
  font-style: normal;
}`;

// import SatoshiMediumItalicWOFF2 from "../fonts/Satoshi-MediumItalic.woff2";
// const SatoshiMediumItalic = `@font-face {
//   font-family: "Satoshi-MediumItalic";
//   src: url(${SatoshiMediumItalicWOFF2}) format("woff2");
//   font-weight: 500;
//   font-display: swap;
//   font-style: italic;
// }`;

// import SatoshiBoldWOFF2 from "../fonts/Satoshi-Bold.woff2";
// const SatoshiBold = `@font-face {
//   font-family: "Satoshi-Bold";
//   src: url(${SatoshiBoldWOFF2}) format("woff2");
//   font-weight: 700;
//   font-display: swap;
//   font-style: normal;
// }`;

// import SatoshiBoldItalicWOFF2 from "../fonts/Satoshi-BoldItalic.woff2";
// const SatoshiBoldItalic = `@font-face {
//   font-family: "Satoshi-BoldItalic";
//   src: url(${SatoshiBoldItalicWOFF2}) format("woff2");
//   font-weight: 700;
//   font-display: swap;
//   font-style: italic;
// }`;

// import SatoshiBlackWOFF2 from "../fonts/Satoshi-Black.woff2";
// const SatoshiBlack = `@font-face {
//   font-family: "Satoshi-Black";
//   src: url(${SatoshiBlackWOFF2}) format("woff2");
//   font-weight: 900;
//   font-display: swap;
//   font-style: normal;
// }`;

// import SatoshiBlackItalicWOFF2 from "../fonts/Satoshi-BlackItalic.woff2";
// const SatoshiBlackItalic = `@font-face {
//   font-family: "Satoshi-BlackItalic";
//   src: url(${SatoshiBlackItalicWOFF2}) format("woff2");
//   font-weight: 900;
//   font-display: swap;
//   font-style: italic;
// }`;

// Fonts are inlined into JS bundle when we import them and they are added into DOM when we add them to this array.
// Use only fonts that you need.
// We don't want to increase the bundle size unnecessarily.
const enabledFonts = [SatoshiMedium];

export const fontDefinitions = enabledFonts.join("\n");
